import {FormType, InspectionUpdate, InspectionUpdateStatus, InspectionUpdateTeam, Status} from "../../javaTypes";
import {t} from "../../i18n";
import ScrollingText from "../../displays/components/ScrollingText";

function Cell({statusMap, team, form, queues} : {
    statusMap: Partial<Record<Status, InspectionUpdateStatus>>,
    team: InspectionUpdateTeam,
    form: FormType,
    queues: Record<string, number[]>
}) {
    const status = statusMap[team.statuses[form.code]];
    let content = <>&nbsp;</>
    if (status?.name === Status.READY) {
        if (queues[form.code] && queues[form.code].includes(team.number)) {
            content = <>{queues[form.code].indexOf(team.number) + 1}</>;
        }
    }
    return <td key={form.code} style={{width: "7.5%", backgroundColor: status?.color, color: 'white', fontWeight: 'bold'}}>{content}</td>
}

export default function StatusGrid({inspectionData, columns, projector, noNames} : {
    inspectionData?: InspectionUpdate,
    columns: number,
    projector?: boolean,
    noNames?: boolean
}) {
    if(!inspectionData) {
        return null;
    }
    const statusMap: Partial<Record<Status, InspectionUpdateStatus>> = {};
    for (let s of inspectionData.statuses ?? []) {
        statusMap[s.name] = s;
    }
    const tables = [];
    let start = 0;
    for (let c = 0; c < columns && inspectionData.forms; c++) {
        const headers = inspectionData.forms.map(form => <th key={form.code}>{form.abbrev.toUpperCase()}</th>)
        headers.push(<th key={"team"} className={"teamNumber"}>{t`Team`}</th>);
        if (!noNames) {
            headers.push(<th key={"name"}>{t`Name`}</th>);
        }

        const teamsInColumn = Math.floor(inspectionData.teams.length / columns) + (inspectionData.teams.length % columns > c ? 1 : 0);
        const rows = inspectionData.teams.slice(start, start + teamsInColumn).map(team => <tr key={team.number}>
            {inspectionData.forms.map(form => <Cell key={form.code} statusMap={statusMap} team={team} form={form} queues={inspectionData.readyQueues}/>)}
            <td className={"teamNumber"}>{team.displayNumber}</td>{noNames ? null : <td style={{textAlign: 'left'}} className={"teamName"}><div className={"teamNameWrapper"}>{team.name}</div></td>}
        </tr>);
        start += teamsInColumn;
        tables.push(<table key={`col_${c}`} className={"status-table"} style={{borderCollapse: 'collapse', width: "100%"}}><tr>{headers}</tr>{rows}</table>);
    }
    return <table width={"100%"} style={{fontSize: projector && inspectionData.teams?.length > 32 ? '16px' : '20px'}} className={"statusGridContainer"}><tr style={{verticalAlign: "top"}}>
        {tables.map((table, idx) => <td key={idx} style={{width: `${100 / columns}%`, padding: "5px"}}>{table}</td>)}
    </tr></table>
}